import React, { Component } from 'react';
import  AuthService  from "../api/authentication.js";
// import "./home.css"

const Auth = new AuthService();
class Publicleft extends Component {

  constructor(props){
    super(props)
    this.state={
      showbuton:false
    }
  }

  componentDidMount(){
    if(Auth.loggedIn()){
        this.setState({
          showbuton:true
        })
    }
  }
  render() {
    
   

    return (
            
      this.props.name && this.props.address ? (
            <div className="column is-one-quarter">
                  <div className="infor-body">
                       <div className="thumbnail-body"> 
                          {
                            this.props.image?
                              <div>
                                 {
                                    this.props.image == "" ?
                                      <div>
                                         {/* <img src="http://macmaplegrove.com/wp-content/uploads/2016/01/MGS-logo.png" /> */}
                                           <i className="fas fa-school font-publicleft "></i>
                                      </div>
                                   :
                                       <div>
                                             <img src={ this.props.image} />
                                       </div>     

                                 }   

                              </div>  
                              :
                              <div>
                                 {/* <img src="http://macmaplegrove.com/wp-content/uploads/2016/01/MGS-logo.png" /> */}
                                 <i className="fas fa-school font-publicleft "></i>
                              </div>  
                          }
                             
                        </div>
                          <h4> <b>{this.props.name}</b></h4>
                          <i className="fas fa-map-marker-alt icon-font1"></i> : <small> {this.props.address}</small>
                  </div>
                  {/* { this.state.showbuton ?
                     <div className="pubulc-side-button-body">
                       <a href="/dashboard" className="button is-success pubulc-side-button">Back to dashboard</a>  
                     </div>:
                     <samp>  </samp>
                  }
                     */}
            </div>
      ):
  
                 <div className="column is-one-quarter">
                        <div className="infor-body">
                          <div className="thumbnail-body"> 
                              {/* <img src="http://macmaplegrove.com/wp-content/uploads/2016/01/MGS-logo.png" /> */}
                              <i className="fas fa-school publie-image-logo"> </i>
                             
                          </div>
                 
                        </div>  

                          {/* { this.state.showbuton ?
                            <div className="pubulc-side-button-body">
                              <a href="/dashboard" className="button is-success pubulc-side-button">Back to dashboard</a>  
                            </div>:
                            <samp>  </samp>
                         } */}
                </div>
  
             

    )

}





}

export default Publicleft;


// WEBPACK FOOTER //
// ./src/component/public/publicleft.js